<!-- 顶部导航栏 -->
<template>
  <div class="menu_wrapper"
       @click="bind_prevent($event)">
    <el-menu ref="menu"
             :default-active="activeIndex"
             class="menu"
             mode="horizontal"
             text-color='#a9aeb8'
             active-text-color='#fc754c'
             @select="handleSelect">
      <li class="logo_wrapper"
          @click="handleSelect('index')">
        <div class="logo">
          <img :src="logo0_bg">
          <img :src="logo_bg">
        </div>
        <!-- <div class="logo_desc">
                    <p class="title">有道智选</p>
                    <div class="description">网易品质推广</div>
                </div> -->
      </li>
      <template v-for="(item, idx) in tab"
                class="menu_item_wrapper">
        <el-menu-item v-if='!reactiveType && !item.sub && !item.reactiveSub'
                      :key="idx"
                      class="menu_item"
                      :index="item.key">{{item.value}}</el-menu-item>
        <el-submenu v-if='!reactiveType && item.sub && !item.reactiveSub'
                    class="menu_item"
                    :index="item.key"
                    :key='idx'>
          <template slot="title">{{item.value}}</template>
          <el-menu-item class="menu_item"
                        v-for="(item_sub, idx_sub) in item.sub"
                        :key="idx_sub"
                        :index="item_sub.key">{{item_sub.value}}</el-menu-item>
        </el-submenu>
      </template>
      <li class="btn_collection">
        <template v-for="(item, idx) in tab"
                  class="menu_item_wrapper reactiveSub">
          <el-submenu v-if='reactiveType && item.reactiveSub'
                      class="menu_item reactiveSub"
                      :index="item.key"
                      :key='idx'>
            <template slot="title">{{item.value}}</template>
            <el-menu-item class="menu_item"
                          v-for="(item_sub, idx_sub) in item.reactiveSub"
                          :key="idx_sub"
                          :index="item_sub.key">{{item_sub.value}}</el-menu-item>
          </el-submenu>
        </template>
        <!-- <el-button @click="toLogin"
                   type="warning"
                   size='mini'
                   plain
                   class="btn_init middle">Login</el-button>
        <el-button v-if="false" @click="bind_toggle_form('cooperation')"
                   type="warning"
                   size='mini'
                   class="btn_active middle">Apply</el-button> -->
      </li>
    </el-menu>
  </div>
</template>

<script>
import tab_data from '../data/tab.js';
import util from '@/util/util.js'
export default {
  data () {
    return {
      activeIndex: 'index',
      tab_data: {},
      reactiveType: false
    };
  },
  computed: {
    tab () {
      return tab_data.data;
    },
    logo_bg () {
      return util.get_img2('logo.png')
    },
    logo0_bg () {
      return require('../../static/youdao.png')
    }
  },
  watch: {
    '$route': 'bind_change_active'
  },
  updated () {
    let path = this.$route.path.slice(1);
    this.activeIndex = path || 'index';
  },
  methods: {
    toLogin() {
      window.location.href = '/login'
    },
    // 根据当前路由改变标签
    bind_change_active () {
      let path = this.$route.path.slice(1);
      this.activeIndex = path;
    },
    // 导航到相应的路由
    handleSelect (key) {
      if (this.activeIndex === key) return false;
      // 百度统计
      window._hmt && window._hmt.push(['_trackEvent', 'tabToggle', key]);
      this.$router.push({
        path: `/${key}`
      });
    },
    bind_prevent (e) {

    },
    // 显示合作/登录组件
    bind_toggle_form (flag) {
      // 百度统计
      window._hmt && window._hmt.push(['_trackEvent', 'ctaTrigger', flag]);
      this.$emit('toggleForm', flag);
    },
    bind_response_setting () {
      // 响应式（tab显示完全至少需要900px）
      let docWidth = document.documentElement.clientWidth || document.body.clientWidth;
      if (docWidth <= 900) {
        this.reactiveType = true;
      } else {
        this.reactiveType = false;
      }
    }
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.fix_timer && clearTimeout(this.fix_timer);
      this.fix_timer = setTimeout(() => {
        this.bind_response_setting();
      }, 100)
    })
    let path = this.$route.path.slice(1);
    this.activeIndex = path;
  }
}
</script>
<style scoped>
@media screen and (max-width: 1280px) {
  .menu_wrapper,
  .menu {
    min-width: 0 !important;
  }
  .menu {
    width: 100%;
  }
}
.menu_wrapper {
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  text-align: center;
  min-width: 1280px;
  background: #fff;
  box-shadow: 0 4px 30px 0 rgba(204, 230, 255, 0.36);
  font-size: 0;
}

.menu_item_wrapper {
  display: inline-block;
}

.logo_wrapper {
  float: left;
  width: 144px;
  /* padding: 20px 30px 0px 0px; */
  margin-right: 140px;
  height: 60px;
  font-size: 0;
}

.logo_wrapper:hover {
  cursor: pointer;
}

.logo {
  /* width: 40px; */
  display: flex;
  align-items: center;
  height: 60px;
}

.logo img {
  display: block;
  height: auto;
  transform: scale(0.85);
}

.logo_desc {
  display: inline-block;
  height: 40px;
  width: 120px;
  color: #18253d;
  text-align: center;
}

.logo_desc .title {
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 2px;
}

.logo_desc .description {
  font-size: 10px;
  letter-spacing: 6px;
  transform: scale(0.8);
  -ms-transform: scale(0.8);
}

.menu {
  min-width: 1280px;
  border-bottom: none !important;
  display: inline-block !important;
  background: #fff;
}

.menu_item.reactiveSub {
  float: left;
  width: 80px;
}

.menu_item:hover {
  color: #fc754c !important;
}

.btn_collection {
  float: right;
  height: 60px;
  line-height: 60px;
}
</style>




// WEBPACK FOOTER //
// src/components/Tab.vue